import { configureStore } from '@reduxjs/toolkit';

import { profileSlice } from 'features/Profile/slices/profileSlice';
import { standSlice } from 'features/Stand/slices';

import { analytics } from 'pages/Analytics/slices';
import { placements } from 'pages/PlacementsStatus/slices';
import { apartmentListSlice } from 'pages/ApartmentList/slices';
import { apartmentsStatus } from 'pages/ApartmentStatus/slices';
import { engineeringStatus } from 'pages/EngineeringNetStatus/slices';
import { defectsSlice } from 'pages/Defects/slices';
import { calls } from 'pages/Calls/slices';
import { plan } from 'pages/Plan/slices';
import { globalNotification } from 'features/GlobalNotification/slices';
import { timeTableSlice } from 'pages/TimeTable/TimeTableApartments/slices';
import { timesheet } from 'pages/Timesheet/slices';
import { startSettlementSlice } from 'pages/StartSettlement/slices';
import { settings } from 'pages/Setting/slices';
import { documentsSlice } from 'pages/Documents/slices';
import { updatesSlice } from 'pages/Updates/slices';
import { uploadingPlansApartmentsSlice } from 'pages/UploadingPlansApartments/slices';
import { deliveryScheduleSlice } from 'pages/DeliverySchedule/slices';
import { deliveryScheduleDetailSlice } from 'pages/DeliveryScheduleDetail/slices';

// TODO оставить одно, это(const reducers) для тестов нужно
export const reducers = {
  analytics,
  apartmentList: apartmentListSlice.reducer,
  apartmentStatus: apartmentsStatus,
  calls,
  defects: defectsSlice.reducer,
  deliverySchedule: deliveryScheduleSlice.reducer,
  deliveryScheduleDetail: deliveryScheduleDetailSlice.reducer,
  documents: documentsSlice.reducer,
  engineeringStatus,
  globalNotification,
  placements: placements,
  plan,
  profile: profileSlice.reducer,
  settings,
  stand: standSlice.reducer,
  startSettlement: startSettlementSlice.reducer,
  timesheet,
  timeTable: timeTableSlice.reducer,
  updates: updatesSlice.reducer,
  uploadingPlans: uploadingPlansApartmentsSlice.reducer,
};

export const store = configureStore({
  reducer: {
    analytics,
    apartmentList: apartmentListSlice.reducer,
    apartmentStatus: apartmentsStatus,
    calls,
    defects: defectsSlice.reducer,
    deliverySchedule: deliveryScheduleSlice.reducer,
    deliveryScheduleDetail: deliveryScheduleDetailSlice.reducer,
    documents: documentsSlice.reducer,
    engineeringStatus,
    globalNotification,
    placements: placements,
    plan,
    profile: profileSlice.reducer,
    settings,
    stand: standSlice.reducer,
    startSettlement: startSettlementSlice.reducer,
    timesheet,
    timeTable: timeTableSlice.reducer,
    updates: updatesSlice.reducer,
    uploadingPlans: uploadingPlansApartmentsSlice.reducer,
  },
});
